import 'twin.macro';
import React from 'react';
import ButtonLink from '@teetsh/app/src/components/Buttons/Link';

export function TooManyRequestsPage() {
  return (
    <main tw="grid min-h-full place-items-center bg-white py-24 px-6 sm:py-32 lg:px-8">
      <div tw="text-center">
        <p tw="text-base font-semibold text-brand-intense">429</p>
        <h1 tw="mt-4 text-3xl font-bold tracking-tight text-neutral-intense sm:text-5xl">
          Trop de requêtes
        </h1>
        <p tw="mt-6 text-base leading-7 text-neutral-quiet">
          Il semblerait que vous ayez fait trop de requêtes. Veuillez patienter
          quelques minutes avant de réessayer.
        </p>
        <div tw="mt-10 flex items-center justify-center gap-x-6">
          <ButtonLink intent="primary" large to="/">
            Retourner à l'accueil
          </ButtonLink>
        </div>
      </div>
    </main>
  );
}
